import { Controller } from "@hotwired/stimulus"

// Controls toggling between Staff and Teacher assignee comboboxes
export default class extends Controller {
  static targets = ["staffField", "teacherField"]

  connect() {
    // Initialize state based on default radio selection
    this.change()
  }

  change() {
    const type = this.currentType()
    if (type === "teacher") {
      this.showTeacher()
    } else {
      this.showStaff()
    }
  }

  currentType() {
    const radios = this.element.querySelectorAll('input[name="assignee_type"]')
    const checked = Array.from(radios).find(r => r.checked)
    return checked ? checked.value : "staff"
  }

  showStaff() {
    this.staffFieldTarget.classList.remove('d-none')
    this.teacherFieldTarget.classList.add('d-none')
    // Enable staff input(s), disable teacher input(s) to avoid submitting both
    this.enableInputs(this.inputsByName('course_transaction[staff_id]'))
    this.enableInputs(this.inputsByName('course_transaction[revenue_staff_ids][]'))
    this.disableAndClearInputs(this.inputsByName('course_transaction[teacher_id]'))
  }

  showTeacher() {
    this.teacherFieldTarget.classList.remove('d-none')
    this.staffFieldTarget.classList.add('d-none')
    // Enable teacher input(s), disable staff input(s) to avoid submitting both
    this.enableInputs(this.inputsByName('course_transaction[teacher_id]'))
    this.disableAndClearInputs(this.inputsByName('course_transaction[staff_id]'))
    this.disableAndClearInputs(this.inputsByName('course_transaction[revenue_staff_ids][]'))
  }

  inputsByName(name) {
    return Array.from(this.element.querySelectorAll(`[name="${name}"]`))
  }

  enableInputs(els) {
    els.forEach(el => el.removeAttribute('disabled'))
  }

  disableAndClearInputs(els) {
    els.forEach(el => {
      el.setAttribute('disabled', 'disabled')
      el.value = ''
    })
  }
}
